import { createSlice } from "@reduxjs/toolkit";

const productDataSlice = createSlice({
  name: "product",
  initialState: { products: [] },
  reducers: {
    getProducts(state, actions) {
      state.products = actions.payload;
    },
  },
});

export const productDataActions = productDataSlice.actions;
export default productDataSlice;
